import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import { insh as inshst } from "../../../Context/InshSt";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
import PumsTable from "./PumsTable";
import PumsForm from "./PumsForm";
import { sto } from "../../../Context/InshData";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";
import PumpsAppbar from "./PumpsAppbar";
import { uri } from "../../../help/Api";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { insh, wsto } from "../../../Context/InshData";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.red[50],
        borderColor: colors.red[300],
    },
}));

export default function Pumps(props) {
    const { AutoOptions,
        branch,
        setBranch
    } = props;
    const clasess = useStyles();
    const optionsItems = AutoOptions?.items.filter((obj) => obj.id !== -1);
    const defaultBranch = AutoOptions.Branches.find((obj) => obj.id === sto.branchi);
    // setBranch(defaultBranch);


    const valuePupms = {
        id: AutoOptions?.other?.lastid ?? 1,
        name: "",
        safe: AutoOptions.Safes[0].id,
        item: optionsItems[0].id,
        branch: branch.id === -1 ? defaultBranch?.id : branch.id,
        count: 0,
    };
    const AutoValuePupms = {
        safe: AutoOptions.Safes[0],
        item: optionsItems[0],
        branch: branch.id === -1 ? defaultBranch : branch,
    };
    const clasCAB = useStylesCAB();
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [prevent, setPrevent] = React.useState(true);
    const [rptParams, setRptParams] = React.useState(valuePupms);
    const [uiElement, setUiElement] = useState({});

    const [rptParamsAuto, setRptParamsAuto] = React.useState(AutoValuePupms);
    const clasBA = useStylesBA();

    const [pumpsReports, setPumpsReports] = React.useState(AutoOptions?.Pumps);


    const { t } = useTranslation(["forms", "translation"]);
    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const timer = React.useRef();
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});
    const his = useHistory();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success?.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };
    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };


    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue.id });
        setRptParamsAuto({ ...rptParamsAuto, [propName]: newValue });
        if (propName === "branch") {
            setBranch(newValue);
        }
    };

    const onRowClick = async (row) => {
        setPrevent(false);
        let res = { branch: {}, item: {}, safe: {} };

        AutoOptions.items.map((x) => {
            if (x.id == row.item) res.item = x;
        });
        AutoOptions.Safes.map((x) => {
            if (x.id == row.safe) res.safe = x;
        });
        AutoOptions.Branches.map((x) => {
            if (x.id == row.branch) res.branch = x;
        });

        setRptParamsAuto({
            ...AutoValuePupms,
            branch: res.branch,
            item: res.item,
            safe: res.safe,
        });

        setRptParams({
            ...rptParams,
            id: row.id,
            count: row.count,
            safe: row.safe,
            branch: row.branch,
            item: row.item,
            name: row.name,
        });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            Pumps: true,
            parms: {
                iempid: sto.empi,
                tname: "pump",
                branch: sto.branchi
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setPumpsReports(res.data?.Pumps);
                setRptParams({
                    ...
                    valuePupms,
                    id: res.data.other?.lastid
                });
                setRptParamsAuto(AutoValuePupms);
            })
            .catch((error) => {
            });
    };

    const handNewPumps = () => {
        reloadGets();
        setRptParamsAuto(AutoValuePupms);
        setRptParams(valuePupms);
        setPrevent(true);
    };
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "save") { handNewPumps(); }
            if (prop === "update") { handNewPumps(); }

            else if (prop === "delete") { handNewPumps(); }
            else {
                handNewPumps();
            }
            setPrevent(true);
        }, 2000);
    };

    const addToBS = (props) => {
        ButtonLoading("save");
        if (rptParams.branch !== "" && rptParams.name != null && rptParams.name != "" &&
            rptParams.item != null && rptParams.safe !== "" && rptParams.safe !== null) {
            prevent
                ? axios
                    .post(uri + "Pumps", rptParams)
                    .then((res) => {
                        if (res.data?.data != null) {

                            ButtonSuccess("save", 1000);
                            toast.success(t("save-success"));
                        } else {
                            ButtonSuccess("save", 1000);
                            toast.success(t("save-success"));
                        }

                    })
                    .catch((res) => {
                        ButtonSuccess("save", 1000);
                        toast.error(t("save-failed"));

                    })
                :
                axios
                    .put(uri + "Pumps", rptParams)
                    .then((res) => {
                        ButtonSuccess("update", 1000);
                        toast.success(t("update-success"));
                    })
                    .catch((res) => {
                        ButtonSuccess("update", 1000);
                        toast.error(t("update-failed"));

                    });
        } else {
            alert(t("complete-data"));
        }
    };



    const handleDeleteRow = async (e, row) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");

        await axios.delete(uri + `Pumps?id=${row?.id}`).then(res => {
            if (res.data==="no"){
                alert(t("cant-delete-pump")); 
            }else{
                toast.success(t("delete-success"));
                ButtonSuccess("delete", 1000);
            }

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };

    const deleteToI = async (e) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");

        await axios.delete(uri + `Pumps?id=${rptParams?.id}`).then(res => {
            toast.success(t("delete-success"));
            ButtonSuccess("delete", 1000);
        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
                    color="primary"
                >
                    {t("define-pumps-screen")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12}className={clasui.rootchip} >

                    <Grid container item lg={6} md={6} sm={6} xm={12} className={clasui.rootchip} >

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <PumsForm
                                {...{
                                    AutoOptions,
                                    rptParams,
                                    rptParamsAuto,
                                    onChangeAutoData,
                                    changTField,
                                    optionsItems
                                }}
                            />

                        </Container>
                    </Grid>
                    <Grid container lg={6} md={6} sm={6} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                marginTop: "0.5rem"
                            }}
                        >
                            <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.red[300]} />
                                    {!fetching && (
                                        <PumsTable
                                            {...{
                                                data: pumpsReports ? pumpsReports : [],
                                                setConfirmDialog,
                                                handleDeleteRow,
                                                onRowClick
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
                <DeleteConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Typography>
            <PumpsAppbar {...{
                rptParams,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent
            }}
            />
        </div>
    );
}
